import { styled } from "@mui/material";
import Component from "./component";

export default styled(Component)(({ theme }) => ({
  display: "grid",
  height: "inherit",
  gridTemplateColumns: "250px auto",
  ".side-menu-cont": {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: 250,
    overflowY: "auto",
  },
  main: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    overflowY: "auto",

    ".MuiAppBar-root": {
      backgroundColor: theme.palette.background.default,
    },
  },
  ".main-header": {
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing(2),
    ".MuiAvatar-root": {
      backgroundColor: "#fff",

      ".MuiSvgIcon-root": {
        color: "#94A3B8",
      },
    },
  },
  ".page-title-container": {
    display: "inline-flex",
    gap: theme.spacing(1),

    h6: {
      color: "#000",
      fontWeight: 600,
      fontSize: 22,
    },
  },
  ".template-container": {
    margin: theme.spacing(2),
  },
  ".margin-auto": {
    margin: "auto",
  },
  ".profile-container": {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  ".menu-section": {
    ".MuiToolbar-root": {
      justifyContent: "center",
    },
  },
  ".profile-name-cont": {
    display: "flex",
    gap: theme.spacing(1),
    color: "#94A3B8",
    h6: {
      fontSize: 14,
      fontWeight: 500,
    },
    p: {
      fontSize: 12,
    },
    ".profile-name": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
  },
}));
